import { MapPin, Boxes, Route, Bell, Gauge, Fuel, Fingerprint, Hexagon, Wrench, Smartphone } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';
import CTABand from '@/components/CTABand';
import { Stagger, StaggerItem } from '@/components/Reveal';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [MapPin, Boxes, Route, Bell, Gauge, Fuel, Fingerprint, Hexagon, Wrench, Smartphone];
const TONES = [
  'bg-brand-blue/8 border-brand-blue/15 text-brand-blue',
  'bg-brand-sky/10 border-brand-sky/20 text-brand-sky',
  'bg-brand-teal/10 border-brand-teal/20 text-brand-teal',
  'bg-brand-violet/10 border-brand-violet/20 text-brand-violet',
];

export default function Services() {
  const { t } = useLanguage();
  const items = t('servicesPage.items');
  return (
    <div className="pt-28" data-testid="services-page">
      <section className="mx-auto max-w-7xl px-5 pt-8 lg:px-8">
        <SectionHeading eyebrow="servicesPage.eyebrow" title="servicesPage.title" sub="servicesPage.sub" align="center" />
        <Stagger className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" gap={0.07}>
          {items.map((s, i) => {
            const Icon = ICONS[i] || MapPin;
            return (
              <StaggerItem key={s.t}>
                <div className="card-hover flex h-full items-start gap-4 rounded-2xl border border-brand-line bg-white p-6" data-testid={`service-card-${i}`}>
                  <span className={`grid h-12 w-12 shrink-0 place-items-center rounded-2xl border ${TONES[i % 4]}`}>
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-brand-ink">{s.t}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-brand-steel">{s.d}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </section>
      <div className="pt-16"><CTABand /></div>
    </div>
  );
}
